import punycode from 'punycode';

class DomainCheck {
    constructor(domainName) {
        this.domainName = domainName;
    }

    isAvailable(callback) {
        $.ajax({
            url: euPortalConfig.euapi_base_uri+'domain_find/'+this.domainName,
            statusCode: {
                404: function() {
                    callback(true); //domain not found so available
                },
                409: function() {
                    callback(false); //domain already used
                },
            }
        });
    }

    isValid () {
        //https://github.com/johno/domain-regex
        const domainRegex = /^(?!\-)(?:[a-zA-Z\d\-]{0,62}[a-zA-Z\d]\.){1,126}(?!\d+)[a-zA-Z\d]{1,63}$/;

        return domainRegex.test(punycode.toASCII(this.domainName));
    }
}

export default DomainCheck;
